<template>
  <div v-if="active" class="modal is-active">
    <div @click="close" class="modal-background"></div>
    <div class="close-container">
      <button @click="close" class="delete close-button is-large" aria-label="close"></button>
    </div>
    <aside class="modal-card">
      <iframe :src="video" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </aside>
  </div>
</template>

<script>
import ModalCustom from '@/components/Modals/Custom'
import componentState from '@/mixins/component-state'
import closeOnEsc from '@/mixins/close-on-esc'
export default {
  components: {
    ModalCustom
  },
  mixins: [componentState, closeOnEsc],
  watch: {
    active: function () {
      if (this.active) {
        this._callback('lockScrolling')
      }
    }
  },
  computed: {
    active: function () {
      return this.$store.getters.modalIsVisible('videotour')
    },
    fromStartButtonTemplate: function () {
      return !!this.$route.params.startButton || this.fromTemplate
    },
    isYSC: function () {
      return this.$isYSC
    },
    isFromResourcesPage: function () {
      return this.modalData.fromResources
    },
    // Any new popup modal videos added, should be dispatched using the flag fromSourcePage
    // as well as the url
    isFromSourcePage: function () {
      return this.modalData.fromSourcePage
    },
    videoURL: function () {
      return this.modalData.url
    },
    modalData: function () {
      return this.$store.getters.modalData('videotour') || {}
    },
    isLandingPage: function () {
      return this.modalData.fromLandingPage
    },
    yscTourVideo: function () {
      return this.$i18n.locale === 'en' ? 'https://www.youtube.com/embed/snhUmlSn_IY' : 'https://www.youtube.com/embed/GvlV3XIu7HI'
    },
    yscVideo: function () {
      return this.isLandingPage ? this.landingPageVideo : this.yscTourVideo
    },
    resourcesLearningVideo: function () {
      return 'https://players.brightcove.net/6019218630001/bLz4bOgEu_default/index.html?videoId=6174489743001'
    },
    video: function () {
      return this.isFromSourcePage ? this.videoURL : this.isYSC ? this.yscTourVideo : 'https://players.brightcove.net/6019218630001/bLz4bOgEu_default/index.html?videoId=6146861291001'
    }
  },
  methods: {
    startTutorial: function () {
      // code to start onboarding tutorial
      this.close()
    },
    close: function () {
      if (!this.fromStartButtonTemplate && !this.isLandingPage && !this.isFromSourcePage) {
        this.$emit('clicked')
      } else {
        this._callback('unlockScrolling')
      }
      this.$store.dispatch('hideVideoTourModal')
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $onboardingcolorcolor: #00ADEE;
  $modal-body-color: #F2F2F2;
  $border-color: #DCDCDC;
  $close-icon-color: #1A051D;
  .modal-card iframe {
    height:100%;
    width:100%;
  }

  .modal-card {
    background: $modal-body-color;
    text-align: center;
    width: 90%;
    height: 65vh;
    margin:0 auto;
    text-align:center;
    overflow:hidden;
    max-width:178vh;
    @include mobile{
      height: 50vh
    }
    @include fullhd {
      height: 80vh;
    }
    @media only screen
      and (min-device-width: 320px)
      and (max-device-width: 768px)
      and (-webkit-min-device-pixel-ratio: 2)
      and (orientation: landscape) {
        height: 65vh;
        width: 80%;
    }
  }
  .close-container {
    width: 90%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }

</style>
